import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { CaseItem } from '../../Contexts/types';
import { useParams } from 'react-router-dom';

// interface CaseDocument {
//   id: string;
//   title: string;
//   url: string;
//   description: string;
// }

interface CaseDetailsProps {
  cases: CaseItem[];
}

interface JudgementApplication {
    applicationReason: string;
    caseId: string;
    case: Case;
    digitalSeal: string;
    signature: string;
    approvalDocument: string[]; // Array of document URLs
    id: string;
    approved: boolean;
    applicationType: string;
}

interface Case {
  suitNumber: string;
}

const JudgementDocuments: React.FC<CaseDetailsProps> = ({ cases }) => {
  const { id } = useParams<{ id: string }>();
  const caseId = id;
  const caseDetails = cases.find((caseItem) => caseItem.basicData.id === id);
  const title = caseDetails?.basicData.title;
  const authToken = sessionStorage.getItem('token');
  const [judgementData, setJudgementData] = useState<JudgementApplication[]>([]);

  useEffect(() => {
    const getCourtRecordsApplications = async () => {
      try {
        const response = await fetch(
          `https://backend-kyw8.onrender.com/court-records?caseId=${caseId}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch court records.');
        }

        const jsonData = await response.json();

        const judgement = jsonData.data.filter(
          (app: JudgementApplication) => app.applicationType === 'JUDGEMENT'
        );

        setJudgementData(judgement);
      } catch (error) {
        console.error('Error fetching ruling data:', error);
      }
    };

    getCourtRecordsApplications();
  }, [caseId, authToken]);

  const columns = [
    {
        title: 'Digital Seal',
        key: 'digitalSeal',
        render: (_text: string, record: JudgementApplication) => (
            <a href={record.digitalSeal} target="_blank" rel="noopener noreferrer">
              View digital seal
            </a>
        ),
    },
    {
        title: 'Signature',
        key: 'signature',
        render: (_text: string, record: JudgementApplication) => (
            <a href={record.signature} target="_blank" rel="noopener noreferrer">
              View Signature
            </a>
        ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_text: string, record: JudgementApplication) => (
        <>
          {record.approvalDocument.map((url, index) => (
            <div key={index}>
              <a href={url} target="_blank" rel="noopener noreferrer">
                View Document {index + 1}
              </a>
            </div>
          ))}
        </>
      ),
    },
  ];

  return (
    <div>
      <div className="form-header">Judgment Documents for {title || 'Unknown Case'}</div>
      <Table
        columns={columns}
        dataSource={judgementData}
        rowKey="id"
        pagination={false}
        className="custom-table ant-table"
      />
    </div>
  );
};

export default JudgementDocuments;
